import InputBasico from './InputBasico'
import Vue, { h } from 'vue'
import { Validations } from '@/utils/Validations'

Vue.config.ignoredElements = ['custom-element']

/**
 * InputTelefone
 */
export const InputTelefone = InputBasico.extend({
    name: 'InputTelefone',
    extends: InputBasico,
    props: {
        label: { default: "Telefone", type: String },
        placeholder: { default: "(00) 0000-0000" },
        mask: { default: "(00) 0000-0000" }
    },
    data: () => ({
        isValid: true,
        isLoading: false,
        lazyValue: ""
    }),
    mounted() {
        const rules = [...this.rules, Validations.isPhoneDddValid, Validations.isPhoneValid]
        this.setRules(rules, this.$props)
        //If mounted with a value
        if (this.value) this.handleInput(this.value);
    }
})

export default InputTelefone

